import React, { Component, PropTypes } from 'react';
import ga from 'react-ga';
import classNames from 'classnames';
import history from 'core/history';
import * as queryString from 'query-string';
import { CategoryType } from 'types';
import ActionCreators from 'actions/ActionCreators';
import CategoryIcon from 'components/CategoryIcon';

import './Category.scss';

/**
 * Кнопка выбора категории.
 */
class Category extends Component {

    static propTypes = {
        category: PropTypes.instanceOf(CategoryType).isRequired
    };

    _onClick = () => {
        const categoryId = this.props.category.id;
        ActionCreators.selectCategory(categoryId);

        ga.event({
            category: 'orders',
            action: 'add_orders_new_s1',
            label: categoryId
        });
        
        // queryString.parse returns object without hasOwnProperty method, but
        // history use it
        const query = Object.assign({}, queryString.parse(window.location.search))

        history.push({
            pathname: `/category/${categoryId}`,
            query: query,
            state: null,
        });
    };

    render() {
        const { category } = this.props;
        return (
            <div className={classNames([
                "Category",
                "-" + this.props.category.id
            ])}
                onClick={this._onClick}
                id={this.props.category.id}>
                <div className="Category-label">
                    <div className="Category-icon">
                        <CategoryIcon category={this.props.category.id}/>
                    </div>
                    {category.title}
                </div>
            </div>
        );
    }

}

export default Category;



// WEBPACK FOOTER //
// ./client/components/Category/Category.js